module.exports = "https://static.zego.com/_next/static/images/Warning-04feac09d433d213d514728e5ce1af08.svg";